import React, { useState, useEffect, Fragment } from 'react';
import services from '../service';
import { Fields, validateProperty, validate, Card } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi, { func } from '@hapi/joi'
import { PageHeader } from '../../../Common';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import groupService from '../../Group/services';
import { SupplierSchemaObject } from '../SupplierSchema';
import FormHelperText from '@material-ui/core/FormHelperText';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { CommonDecryptParam } from '../../../../utils/CommonParams';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { TableContentDelete } from '../../Common/Table/tableContent';
import Autocomplete from '@material-ui/lab/Autocomplete';

const screenCode = 'EXPORTSUPPLIERCREATION';

export function SupplierAddEdit(props) {

    const [title, setTitle] = useState("Add Supplier");
    const [buttonName, setButtonName] = useState("Save")
    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState();
    const [collectionPoints, setCollectionPoints] = useState()
    const [collectionCategory, setCollectionCategory] = useState();
    const [isEditScreen, setIsEditScreen] = useState(false);
    const [products, setProducts] = useState([]);
    const [productList, setProductList] = useState([]);
    const [supplier, setSupplier] = useState({
        groupID: '0',
        operationEntityID: '0',
        collectionPointID: '0',
        supplierCode: '',
        title: '0',
        firstName: '',
        secondName: '',
        lastName: '',
        gender: '0',
        dateOfBirth: new Date().toISOString().split('T')[0],
        nic: '',
        address1: '',
        address2: '',
        address3: '',
        city: '',
        countryCode: '0',
        homePhoneNo: '',
        officePhoneNo: '',
        mobileNo: '',
        email: '',
        question: '',
        answer: '',
        registrationNumber: '',
        nameToBePrinted: '',
        collectionTypeID: '0',
        productsArray: products
    });
    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const[isProductAdded, setIsProductAdded] = useState(false);
    const encriptedTest = props.match.params["id"];
    const id = (encriptedTest !== undefined) ? CommonDecryptParam(props.match.params["id"]) : 0;
    const data = id > 0 ? true : false;
    const edit = id > 0 ? true : false;

    const schema = Joi.object(SupplierSchemaObject).options({ allowUnknown: true });
    const contentRowNames = ["collectionTypeName"];
    const [randomValue, setRandomValue] = useState(0);

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
        )
    }, [supplier.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionCategory(),
            getCollectionPointIDForDropdown()
        )
    }, [supplier.operationEntityID])

    useEffect(() => {
        trackPromise(
            getProducts()
        )
    }, [supplier.collectionPointID]);

    useEffect(() => {
        if (products.filter(x => parseInt(x.state) !== 2).length > 0) {
            setIsProductAdded(true);
        } else {
            setIsProductAdded(false);
        }
    }, [products])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITEXPORTSUPPLIERCREATION');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSupplier({
            ...supplier,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropdown();

        if (data && edit) {
            getSelectedSupplierData();
            setTitle("Edit Supplier");
            setButtonName("Update");
            setIsEditScreen(true);
        } else {
            setTitle("Add Supplier");
        }
    }

    async function getSelectedSupplierData() {
        const data = await services.GetSupplierByID(id);
        if (data !== undefined || data !== null)
            setEditScreenData(data);
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntitiesForDropdown() {
        const operationEntity = await services.getMultiCropsByGroupID(supplier.groupID);
        setOperationEntity(operationEntity);
    }

    async function getCollectionPointIDForDropdown() {
        const collectionPoints = await services.GetCollectionPointByoperationEntityID(supplier.operationEntityID);
        setCollectionPoints(collectionPoints);
    }

    async function getCollectionCategory() {
        const collectionCategories = await services.GetCollectionCategoryByOperationEntityID(supplier.operationEntityID);
        setCollectionCategory(collectionCategories);
    }

    async function getProducts() {
        const productsLists = await services.GetCollectionTypeByCollectionPointForSearcahbleDropDown(supplier.collectionPointID);
        setProductList(productsLists);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    function handleChange(e) {

        const target = e.target
        const value = target.value;

        const error = { ...errors }
        const errorMessage = validateProperty(target, SupplierSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setSupplier({
            ...supplier,
            [e.target.name]: value
        });

        setErrors(error);
    }

    function handleSearchDropdownChange(data) {

        if (data === undefined || data === null)
            return;

        var nameV = "collectionTypeID";
        var valueV = data["collectionTypeID"];

        const error = { ...errors }
        const errorMessage = validateProperty({name: nameV,  value : valueV}, SupplierSchemaObject)
        errorMessage ? error[nameV] = errorMessage : delete error[nameV];

        setSupplier({
            ...supplier,
            collectionTypeID: valueV.toString()
        });

        setErrors(error);
    }

    async function setEditScreenData(data) {
        var productArray = await services.GetSupplierCollectionTypes(id);
        setProducts(productArray);
        setSupplier({
            groupID: data.groupID,
            operationEntityID: data.operationEntityID,
            collectionPointID: data.collectionPointID,
            supplierCode: data.customerCode,
            title: data.titleID,
            firstName: data.firstName,
            secondName: data.secondName,
            lastName: data.lastName,
            gender: data.genderID,
            dateOfBirth: data.dateOfBirth.split('T')[0],
            nic: data.nic,
            address1: data.address1,
            address2: data.address2,
            address3: data.address3,
            city: data.cityID,
            countryCode: data.countryID,
            homePhoneNo: data.homePhoneNo,
            officePhoneNo: data.officePhoneNo,
            mobileNo: data.mobileNo,
            email: data.email,
            question: data.questionID,
            answer: data.answer,
            collectionTypeID: '0',
            registrationNumber: data.registrationNumber,
            nameToBePrinted: data.nameToBePrinted,
            productsArray: products
        });
    }

    async function handleSave(e) {
        e.preventDefault();

        const errorMessages = validate(schema, supplier);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return

        var supplierDetails = {
            customerID: (data && edit) ? parseInt(id) : 0,
            groupID: parseInt(supplier.groupID),
            operationEntityID: parseInt(supplier.operationEntityID),
            collectionPointID: parseInt(supplier.collectionPointID),
            customerCode: supplier.supplierCode,
            titleID: supplier.title,
            firstName: supplier.firstName,
            secondName: supplier.secondName,
            lastName: supplier.lastName,
            genderID: supplier.gender,
            dateOfBirth: supplier.dateOfBirth,
            nic: supplier.nic,
            address1: supplier.address1,
            address2: supplier.address2,
            address3: supplier.address3,
            cityID: supplier.city,
            countryID: supplier.countryCode,
            homePhoneNo: supplier.homePhoneNo,
            officePhoneNo: supplier.officePhoneNo,
            mobileNo: supplier.mobileNo,
            email: supplier.email,
            questionID: supplier.question,
            answer: supplier.answer,
            registrationNumber: supplier.registrationNumber,
            nameToBePrinted: supplier.nameToBePrinted,
            productsArray: products
        }

        let response;
        if (!edit) {
            response = await services.saveSupplier(supplierDetails);
        } else {
            response = await services.updateSupplier(supplierDetails);
        }

        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode)
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/exportSupplier' });
            }, 1500);
        }
    }

    function handleAddProduct() {
        if (parseInt(supplier.collectionTypeID) === 0) {
            setErrors({
                ...errors,
                product: "Please select Product."
            });
            return;
        } else {
            deleteProductErrorMessage();
        }

        var selectedProduct = productList.find((x, index) => x.collectionTypeID === parseInt(supplier.collectionTypeID));

        var productsCopy = [...products];
        var isProductAdded = productsCopy.find(f => parseInt(f.collectionTypeID) === parseInt(supplier.collectionTypeID));

        if (isProductAdded) {
            setErrors({
                ...errors,
                product: isProductAdded.collectionTypeName + " already added"
            });
            return;
        } else {
            deleteProductErrorMessage();
        }

        const supplireProduct = {
            collectionTypeName: selectedProduct.collectionTypeName,
            collectionTypeID: parseInt(supplier.collectionTypeID),
            state: 1
        }

        setRandomValue(Math.random());
        setProducts([...products, supplireProduct]);
    }

    function handleClick(data) {
        deleteProductErrorMessage();
        var allProducts = [...products]

        var selectedProduct = allProducts.filter(x => (parseInt(x.collectionTypeID) === parseInt(data.collectionTypeID)));
        var indexOfSelectedProduct = 0;

        allProducts.forEach((x, i) => {
            if ((parseInt(x.collectionTypeID) === parseInt(data.collectionTypeID))) {
                indexOfSelectedProduct = i;
            }
        });

        var updatedArray = allProducts.filter(x => (parseInt(x.collectionTypeID) !== parseInt(data.collectionTypeID)));

        if (selectedProduct[0].state === 0) {
            allProducts[indexOfSelectedProduct].state = 2;
            setProducts(allProducts);
        } else {
            setProducts(updatedArray);
        }
    }

    function deleteProductErrorMessage() {
        const error = { ...errors };
        delete error["product"];
        setErrors(error);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function clearState() {
        setSupplier({
            ...supplier,
            operationEntityTypeID: "0",
            collectionPointID: "0",
            supplierCode: '',
            title: '',
            firstName: '',
            secondName: '',
            lastName: '',
            gender: '',
            dateOfBirth: new Date().toISOString().split('T')[0],
            nic: '',
            address1: '',
            address2: '',
            address3: '',
            city: '',
            countryCode: '',
            homePhoneNo: '',
            officePhoneNo: '',
            mobileNo: '',
            email: '',
            question: '',
            answer: '',
            registrationNumber: (isEditScreen) ? data.registrationNumber : '',
            nameToBePrinted: (isEditScreen) ? data.nameToBePrinted : '',
            raceID: '0'
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div>
                        <div className="card">
                            <PageHeader
                                title={title}
                                isButtonEnable={true}
                                buttonText="Back to Listing"
                                path="/exportSupplier"
                            />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled || isEditScreen}
                                            name="groupID"
                                            value={supplier.groupID}
                                            disabled={isEditScreen}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="operationEntityID">Company *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled || isEditScreen}
                                            name="operationEntityID"
                                            value={supplier.operationEntityID}
                                            disabled={isEditScreen}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Company--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Collection Point *"
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={supplier.collectionPointID}
                                            disabled={isEditScreen}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(collectionPoints)}
                                        </TextField>
                                        {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Supplier Code *"
                                            name="supplierCode"
                                            id="supplierCode"
                                            value={supplier.supplierCode}
                                            disabled={isEditScreen}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["supplierCode"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["supplierCode"]}</FormHelperText>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <PageHeader
                                title="Supplier Details" />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4">
                                        <InputLabel shrink id="title">Title</InputLabel>
                                        <Select
                                            fullWidth
                                            id="title"
                                            name="title"
                                            value={supplier.title}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Title--</MenuItem>
                                            <MenuItem value="1">Mr.</MenuItem>
                                            <MenuItem value="2">Mrs.</MenuItem>
                                            <MenuItem value="3">Ms.</MenuItem>
                                        </Select>
                                        {errors["title"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["title"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField fullWidth label="First Name *"
                                            name="firstName"
                                            id="firstName"
                                            value={supplier.firstName}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["firstName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["firstName"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Second Name"
                                            name="secondName"
                                            id="secondName"
                                            value={supplier.secondName}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["secondName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["secondName"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="row row-top-gap">
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Last Name"
                                            name="lastName"
                                            id="lastName"
                                            value={supplier.lastName}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["lastName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["lastName"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="gender">Gender</InputLabel>
                                        <Select
                                            fullWidth
                                            id="gender"
                                            name="gender"
                                            value={supplier.gender}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Gender--</MenuItem>
                                            <MenuItem value="1">Male</MenuItem>
                                            <MenuItem value="2">Female</MenuItem>
                                        </Select>
                                        {errors["gender"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["gender"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Date Of Birth"
                                            name="dateOfBirth"
                                            id="dateOfBirth"
                                            value={supplier.dateOfBirth}
                                            type="date"
                                            maxLength="50"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["dateOfBirth"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["dateOfBirth"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="NIC *"
                                            name="nic"
                                            id="nic"
                                            value={supplier.nic}
                                            type="text"
                                            maxLength="12"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["nic"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["nic"]}</FormHelperText>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <PageHeader
                                title="Address" />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Address1 "
                                            name="address1"
                                            id="address1"
                                            value={supplier.address1}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["address1"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["address1"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Address 2"
                                            name="address2"
                                            id="address2"
                                            value={supplier.address2}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["address2"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["address2"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Address 3"
                                            name="address3"
                                            id="address3"
                                            value={supplier.address3}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["address3"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["address3"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="City"
                                            name="city"
                                            id="city"
                                            value={supplier.city}
                                            type="text"
                                            maxLength="50"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["city"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["city"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="countryCode">Country</InputLabel>
                                        <Select
                                            fullWidth
                                            id="countryCode"
                                            name="countryCode"
                                            value={supplier.countryCode}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Country--</MenuItem>
                                            <MenuItem value="1">Afghanistan</MenuItem>
                                            <MenuItem value="2">Canada</MenuItem>
                                            <MenuItem value="3">France</MenuItem>
                                            <MenuItem value="4">Hungary</MenuItem>
                                            <MenuItem value="5">Sri Lanka</MenuItem>
                                            <MenuItem value="6">Ukraine</MenuItem>
                                        </Select>
                                        {errors["countryCode"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["countryCode"]}</FormHelperText>}
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="card">
                            <PageHeader
                                title="Contact" />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Home Phone No"
                                            name="homePhoneNo"
                                            id="homePhoneNo"
                                            value={supplier.homePhoneNo}
                                            type="text"
                                            maxLength="25"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["homePhoneNo"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["homePhoneNo"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Office Phone No"
                                            name="officePhoneNo"
                                            id="officePhoneNo"
                                            value={supplier.officePhoneNo}
                                            type="text"
                                            maxLength="25"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["officePhoneNo"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["officePhoneNo"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Mobile No"
                                            name="mobileNo"
                                            id="mobileNo"
                                            value={supplier.mobileNo}
                                            type="text"
                                            maxLength="25"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["mobileNo"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["mobileNo"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Email"
                                            name="email"
                                            id="email"
                                            value={supplier.email}
                                            type="text"
                                            maxLength="25"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["email"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["email"]}</FormHelperText>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <PageHeader
                                title="Verification" />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col pb-1">
                                        <TextField fullWidth label="Question"
                                            name="question"
                                            id="question"
                                            value={supplier.question}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["question"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["question"]}</FormHelperText>}
                                    </div>
                                    <div className="col pb-1">
                                        <TextField fullWidth label="Answer"
                                            name="answer"
                                            id="answer"
                                            value={supplier.answer}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["answer"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["answer"]}</FormHelperText>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <PageHeader
                                title="Card Details" />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col pb-1">
                                        <TextField fullWidth label="Registration Number *"
                                            name="registrationNumber"
                                            id="registrationNumber"
                                            value={supplier.registrationNumber}
                                            type="text"
                                            onChange={(e) => handleChange(e)}
                                            disabled={isEditScreen}
                                        />
                                        {errors["registrationNumber"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["registrationNumber"]}</FormHelperText>}
                                    </div>
                                    <div className="col pb-1">
                                        <TextField fullWidth label="Name to be printed *"
                                            name="nameToBePrinted"
                                            id="nameToBePrinted"
                                            value={supplier.nameToBePrinted}
                                            type="text"
                                            onChange={(e) => handleChange(e)}
                                            disabled={isEditScreen}
                                        />
                                        {errors["nameToBePrinted"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["nameToBePrinted"]}</FormHelperText>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <PageHeader
                                title="Products" />
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-4">
                                        <Autocomplete
                                            id="collectionTypeIDy"
                                            options={productList}
                                            key={randomValue}
                                            getOptionLabel={(option) => option.collectionTypeName.toString()}
                                            onChange={(e, value) => handleSearchDropdownChange(value)}
                                            renderInput={(params) => <TextField {...params} label="Product *" variant="outlined" size="small"/>}
                                        />
                                        {errors["collectionTypeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionTypeID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">
                                        <div className="float-left">
                                            <input
                                                type="button"
                                                className="btn btn-primary"
                                                style={{height: "40px"}}
                                                onClick={handleAddProduct}
                                                value="Add"
                                            />
                                        </div>
                                    </div>
                                </div>
                                {errors["product"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["product"]}</FormHelperText>}
                                {(products.length > 0) ? <div className="row">
                                    <div className="col">
                                        <div className="table-responsive row-top-gap">
                                            <table className="display dataTable no-footer">
                                                <thead>
                                                    <tr>
                                                        <th>Product Name</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <TableContentDelete
                                                        data={products.filter(x => parseInt(x.state) !== 2)}
                                                        contentRowNames={contentRowNames}
                                                        hasEdit={true}
                                                        handleClick={handleClick}
                                                    />
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div> : null}
                            </div>
                        </div>
                    </div>
                    <div>
                        <input
                            disabled={(validate(schema, supplier) === null ? false : true) || !isProductAdded}
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSave}
                            value={buttonName}
                        />

                        <input type="reset" className="btn btn-warning pull-right"
                            onClick={clearState}
                            value="Clear"
                            hidden={isEditScreen}
                        />
                    </div>
                    <MessageModal
                        hidden={messageModel.hidden}
                        messageType={messageModel.type}
                        messageDescription={messageModel.disciption}
                        clicked={modalDismissHandler}
                    />
                </div>
            </div>
        </Fragment >
    );
}